import React from "react";
import styled, { css } from "styled-components";
import _Select from "react-select";
import { fontSize, rtl } from "../common/styled-mixins";

const Select = styled(_Select)`
  height: 40px;
  min-width: 180px;
  font-weight: 400;
  font-size: ${fontSize(16)};
  line-height: 1;

  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `};

  @media (max-width: 959px) {
    height: 32px;
    font-size: ${fontSize(14)};
  }

  .react-select__control {
    height: 100%;
    font-size: inherit;
    line-height: inherit;
    border: 1px solid #cccccc;
    border-radius: 4px;
    background-color: ${({ theme }) =>
      theme.calendarBackground ? theme.mainDark : "#fff"};
    color: ${({ theme }) =>
      theme.calendarInputColor
        ? theme.calendarInputColor + " !important"
        : "#4e2a81"};
  }

  .react-select__single-value {
    color: ${({ theme }) =>
      theme.calendarInputColor
        ? theme.calendarInputColor + " !important"
        : "#4e2a81"};
  }

  .react-select__value-container,
  .react-select__placeholder {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: flex-start;
    align-items: center;
    font-size: inherit;
    line-height: inherit;
    height: 100%;
    color: rgb(207, 207, 207);
  }

  .react-select__value-container--has-value {
    color: #4e2a81;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__dropdown-indicator {
    ${rtl("padding-left", 0)};
  }

  .react-select__menu {
    background-color: ${({ theme }) =>
      theme.calendarBackground && theme.mainDark};
    margin-top: 0;
  }

  .react-select__option {
    background-color: ${({ theme }) =>
      theme.calendarBackground && theme.mainDark};
    color: ${({ theme }) =>
      theme.calendarBackground && "rgba(255, 255, 255, 0.58)"};
    &--is-selected {
      background-color: ${({ theme }) =>
        theme.calendarBackground && theme.mainLight};
      color: ${({ theme }) => theme.calendarBackground && "#ffffff"};
    }

    &--is-focused {
      background-color: ${({ theme }) =>
        theme.calendarBackground && theme.mainLight};
      color: ${({ theme }) => theme.calendarBackground && "#ffffff"};
    }
  }
`;

export default ({ options, className, onChange, minWidth, ...other }) => {
  const logChange = val => {
    console.log(`selected value: ${val.value}`);
  };

  return (
    <Select
      className={className}
      classNamePrefix="react-select"
      options={options}
      onChange={onChange || logChange}
      isClearable={false}
      isSearchable={false}
      isMulti={false}
      {...other}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/HistoryPages/Select.js